var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 12.1599V13.3334C14.1667 14.7141 13.0474 15.8334 11.6667 15.8334H4.16669C2.78598 15.8334 1.66669 14.7141 1.66669 13.3334V6.66675C1.66669 5.28604 2.78598 4.16675 4.16669 4.16675H11.6667C13.0474 4.16675 14.1667 5.28604 14.1667 6.66675V7.24497L16.2278 5.31004C17.0259 4.56079 18.3334 5.12668 18.3334 6.22138V13.4734C18.3334 14.6108 16.9377 15.1571 16.1655 14.3219L14.1667 12.1599ZM4.16669 5.83341H11.6667C12.1269 5.83341 12.5 6.20651 12.5 6.66675V13.3334C12.5 13.7937 12.1269 14.1667 11.6667 14.1667H4.16669C3.70645 14.1667 3.33335 13.7937 3.33335 13.3334V6.66675C3.33335 6.20651 3.70645 5.83341 4.16669 5.83341ZM14.1667 9.70482L16.6667 12.4089V7.18404L14.1667 9.53098V9.70482Z",
    fill: "#333843"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.4095e427aa4999d6d8b4a948cc942e31.svg";
export { ForwardRef as ReactComponent };